import React from 'react'
import AddNewCategoryContainer from '../../../../Components/Category/AddNewCategoryContainer/AddNewCategoryContainer'
import Layout from '../../Layout'
const AddNewCategory = () => {
  return (
    <Layout>
      <AddNewCategoryContainer/>
    </Layout>
  )
}

export default AddNewCategory